import Base from "components/Creation/components/Base";
import { Fragment, useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import Checkmark from "../checkmark";
import useSelection from "../../../../hooks/useSelection";
import { useHistory } from "react-router-dom";
import MirumModal from "components/MirumModal";
import Warning from "../Warning";

const Where = () => {
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState({
    north: false,
    south: false,
    east: false,
    west: false,
    "central-east": false,
    "central-west": false,
    "south-east": false,
    "south-west": false,
  });

  const {
    setSelectionForKey,
    keyIsValidated,
    keysAreValidatedUptoButNotIncluding,
  } = useSelection({
    key: "where",
    setter: setSelectedLocations,
  });

  const onSelectedLocation = ({ locationName, isSelected }) => {
    setShouldAnimate(false);
    setSelectionForKey({
      ...selectedLocations,
      [locationName]: isSelected,
    });
  };

  const [shouldAnimate, setShouldAnimate] = useState(true);

  const Location = ({
    locationName,
    style,
    width,
    top,
    left,
    locationColor,
  }) => {
    let isSelected = selectedLocations[locationName];
    style = {
      width: `${width}%`,
      top: `${top}%`,
      left: `${left}%`,
      ...style,
    };
    const toggleSelection = () => {
      onSelectedLocation({ locationName, isSelected: !isSelected });
    };

    const DELAY_ANIMATION =
      Object.keys(selectedLocations).findIndex((key) => key === locationName) *
      250;

    return (
      <>
        {/* DESKTOP */}
        <div
          className={`hidden md:block md:absolute cursor-pointer`}
          style={style}
          onClick={toggleSelection}
        >
          <div
            className="hidden md:block relative left-[-50%] top-[-50%] w-full"
            // style={{ left: "-50%", top: "-50%", width: "100%" }}
          >
            <Animated
              animationIn={`${shouldAnimate ? "pulse" : "none"}`}
              animationInDelay={DELAY_ANIMATION}
              animationInDuration={500}
            >
              <img
                className="w-full"
                src={`/images/where/${locationName}/${locationName}.png`}
                alt={locationName}
              />

              <div className="absolute h-full w-full flex items-center justify-center top-0 left-0">
                <div
                  className="text-center py-2 px-4 z-20 pointer-events-none z-20 capitalize relative"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "10px",
                    border: "3px solid grey",
                    borderColor: isSelected
                      ? `var(--location-colour-${locationName})`
                      : "var(--light-grey)",
                  }}
                >
                  <div className="flex items-center gap-1 lowercase font-bold">
                    {locationName.split("-").join(" ")}
                    {isSelected && (
                      <div className="absolute top-[-16px] right-[-15px]">
                        <Checkmark style={{ fontSize: "0.9em" }} />
                      </div>
                    )}
                  </div>
                </div>

                <img
                  className={`${
                    isSelected ? "opacity-100" : "opacity-5"
                  } hover:opacity-100 w-full absolute top-0 left-0 z-10`}
                  src={`/images/where/${locationName}/selected-${locationName}.png`}
                  alt={locationName}
                />
              </div>
            </Animated>
          </div>
        </div>

        {/* MOBILE */}
        <div
          className={`block md:hidden w-full relative my-4 rounded-sm  cursor-pointer`}
          onClick={toggleSelection}
        >
          <img
            src={`/images/where/mobile/${locationName}/${locationName}.png`}
            className="top-0 left-0 z-5 relative"
          />
          <img
            className={`${
              isSelected ? "opacity-100" : "opacity-5"
            } hover:opacity-100 w-full absolute top-0 left-0 z-10`}
            src={`/images/where/mobile/${locationName}/selected-${locationName}.png`}
            alt={locationName}
          />
          <div className="absolute h-full w-full flex items-center justify-center top-0 left-0">
            <div
              className="text-center py-2 px-4 pointer-events-none z-10 capitalize relative"
              style={{
                backgroundColor: "white",
                borderRadius: "10px",
                border: "3px solid grey",
                borderColor: isSelected
                  ? `var(--location-colour-${locationName})`
                  : "var(--light-grey)",
              }}
            >
              <div className="flex items-center gap-1 lowercase font-bold">
                {locationName.split("-").join(" ")}
                {isSelected && (
                  <div className="absolute top-[-16px] right-[-15px]">
                    <Checkmark style={{ fontSize: "0.9em" }} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  let history = useHistory();

  useEffect(() => {
    console.log("WHERE rendered where");
  }, []);

  return (
    <Fragment>
      <MirumModal
        show={showErrorMsg}
        onPositiveBtnClick={() => {
          setShowErrorMsg(false);
        }}
        onDidDismiss={() => {
          setShowErrorMsg(false);
        }}
        hideNegativeBtn={true}
      >
        <div>
          <h1>select a location</h1>
          <p className="my-4">
            please ensure you've selected at least 1 location before proceeding
          </p>
        </div>
      </MirumModal>
      <Base
        title="Where?"
        footerOnClickedNext={() => {
          console.log("NEXT CLICKED");
          if (keyIsValidated("where")) {
            history.push("/when");
          } else {
            setShowErrorMsg(true);
          }
        }}
        infoBody="select the area(s) in London you’d be open to travelling to"
      >
        <p className="lowercase relative z-20 mb-8">(Select all that apply)</p>
        <div className="w-full relative top-[-20px]">
          <div className="absolute w-full h-full top-0 left-0 z-1">
            <img
              className="w-full h-full object-cover opacity-90 md:opacity-100"
              src="/images/where/bg.jpg"
            />
          </div>
          <div
            className="mx-auto w-11/12 grow relative"
            // style={{ backgroundColor: "red" }}
          >
            <div
              className="w-full md:pb-[56.25%] md:relative top-0 left-0"
              style={
                {
                  // top: 0,
                  // left: 0,
                  // height: "auto",
                }
              }
            >
              <div className="w-full md:absolute md:h-full block top-[-5%] left-0 z-10">
                <Location
                  locationName="north"
                  width={30.5}
                  left={50}
                  top={10}
                />
                <Location
                  locationName="west"
                  width={20}
                  left={16.5}
                  top={31.5}
                />
                <Location
                  locationName="central-west"
                  width={23}
                  left={39}
                  top={31}
                />
                <Location
                  locationName="central-east"
                  width={20}
                  left={61.5}
                  top={31}
                />
                <Location locationName="east" width={15} left={79} top={15} />
                <Location
                  locationName="south-west"
                  width={17}
                  left={29}
                  top={59}
                />
                <Location
                  locationName="south"
                  width={25}
                  left={51.5}
                  top={56}
                />
                <Location
                  locationName="south-east"
                  width={20}
                  left={76.4}
                  top={53}
                />
              </div>
            </div>
          </div>
        </div>
        {!keyIsValidated("where") && (
          <Warning
            msg="please select at least 1 location"
            className="mt-[-7%]"
          />
        )}
      </Base>
    </Fragment>
  );
};

export default Where;
